import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import ClinicalStudies from "../../components/Studies";
import { LOADER_STATUS } from "../../constant/Data";
import PricingCards from "../landingPage/components/vsl/pricing";
import WhyOrder from "../landingPage/components/vsl/whyOrder";
import Gurantee from "../landingPage/components/vsl/gurantee";
import Bonuses from "../landingPage/components/vsl/Bonuses";
import Contact from "../landingPage/components/vsl/Contact";
import Testimonials from "../../components/testomonials";
import FAQ from "../landingPage/components/vsl/Faq";
import NotificationRotator from "../landingPage/components/vsl/RecentPurchase";
import TherapistInfo from "../landingPage/components/vsl/TherapistInfo";
import CommentSection from "../landingPage/components/vsl/Comments";
import Header from "../landingPage/components/Header";
import Hero from "../landingPage/components/Hero";
import Features from "../landingPage/components/Features";
import ScienceBack from "../landingPage/components/ScienceBack";
import Pricing from "../landingPage/components/Pricing";
import GuranteeLicence from "../landingPage/components/GuranteeLicence";
import FAQs from "../landingPage/components/FAQs";
import Footer from "../landingPage/components/Footer";

function Fe() {
  const [isShowVsl, setIsShowVsl] = useState(-1);
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoParamExists, setIsVideoParamExists] = useState(null);
  const location = useLocation();
  const pricingRef = useRef(null);
  const [startTimer, setStartTimer] = useState(false);
  const [isVideoPlay, setIsVideoPlay] = useState(null);

  useEffect(() => {
    if (isShowVsl === -1 && location) {
      setIsShowVsl(0);
      const { search } = location;
      const params = new URLSearchParams(search);
      const hasAnyParam = Array.from(params.entries()).length > 0;
      setIsVideoParamExists(hasAnyParam);

      setIsShowVsl(1);
    }
  }, [location]);

  const maximizeVideo = () => {
    setIsVideoPlay(LOADER_STATUS.PLAY);

    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    // Get the actual viewport height
    const vh = window.innerHeight;

    // Apply styles
    video.style.maxWidth = "100%";
    video.style.height = `${vh}px`;
    video.style.padding = "0px";
    video.style.backgroundColor = "#000";

    vidwrapper.style.height = `${vh}px`;
    vidwrapper.style.width = "100%";

    vidwrappervid.style.height = `${vh}px`;
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "contain";
    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "contain";
    }
  };

  const minimizeVideo = () => {
    // console.log("Minimize Video");
    const video = document.querySelector("#smartplayer");
    const vidwrapper = document.querySelector("#smartplayer > div");
    const vidwrappervid = document.querySelector(
      "#smartplayer > div > div.smartplayer-video-wrap > video"
    );

    video.style.padding = "20px";
    video.style.maxWidth = "900px";
    video.style.height = "480px";
    video.style.backgroundColor = "transparent";

    vidwrapper.style.height = "100%";
    vidwrapper.style.width = "100%";

    vidwrappervid.style.height = "100%";
    vidwrappervid.style.width = "100%";
    vidwrappervid.style.objectFit = "cover";

    vidwrappervid.style.transform = "scale(1)";
    vidwrappervid.style.transformOrigin = "top left";

    if (window.innerWidth < 700) {
      vidwrappervid.style.objectFit = "cover";
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (isVideoPlay === LOADER_STATUS.PLAY) {
        maximizeVideo();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isVideoPlay]);

  useEffect(() => {
  const SECONDS_TO_DISPLAY = 2733;
  const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
  let elsDisplayed = false;
  let attempts = 0;
  let isFirstPlay = !localStorage.getItem(alreadyDisplayedKey);

  // Show hidden elements function
  const showHiddenElements = () => {
    if (elsDisplayed) return;
    elsDisplayed = true;

    setIsVisible(true);
    localStorage.setItem(alreadyDisplayedKey, "true");

    const hiddenEls = document.querySelectorAll("#Hidden");
    hiddenEls.forEach((el) => (el.style.display = "block"));

    if (isFirstPlay) {
      const firstHidden = document.querySelector("#Hidden");
      firstHidden?.scrollIntoView({ behavior: "smooth", block: "start" });
      isFirstPlay = false;
    }

  };

  // Function to attach listeners once player is ready
  const attachVideoEventListeners = (player) => {
    player.on("play", () => {
      // Maximize every time video plays
      maximizeVideo();
      setIsVideoPlay(LOADER_STATUS.PLAY);
    });

    player.on("pause", () => {
      setIsVideoPlay(LOADER_STATUS.PAUSE);
      minimizeVideo();
    });

    player.on("timeupdate", () => {
      if (elsDisplayed || player.smartAutoPlay) return;
      if (player.video.currentTime >= SECONDS_TO_DISPLAY) {
        showHiddenElements();
      }
    });
  };

  // Wait for smartplayer instances to be ready, retry if not
  const waitForSmartPlayer = () => {
    if (
      window.smartplayer &&
      window.smartplayer.instances &&
      window.smartplayer.instances.length > 0
    ) {
      const player = window.smartplayer.instances[0];
      player.options.autoplay = false;
      player.smartAutoPlay = false;
      attachVideoEventListeners(player);

      if (localStorage.getItem(alreadyDisplayedKey) === "true") {
        showHiddenElements();
      }
    } else {
      attempts++;
      if (attempts < 10) {
        setTimeout(waitForSmartPlayer, 1000);
      }
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForSmartPlayer);
  } else {
    waitForSmartPlayer();
  }

  // Initially hide all #Hidden elements
  const hiddenEls = document.querySelectorAll("#Hidden");
  hiddenEls.forEach((el) => (el.style.display = "none"));

}, []);

  useEffect(() => {
    if (isVisible && pricingRef.current) {
      pricingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    if (pricingRef.current) observer.observe(pricingRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && !startTimer) {
      setStartTimer(true);
    }
  }, [isVisible, startTimer]);

  const [vid, setVid] = useState("");

  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc?.vid) {
        setVid(window.clickmagick_cmc.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  const skipVideoAndShowCTA = () => {
    const video = document.querySelector("video");
    if (video) {
      video.currentTime = 2733;
      video.dispatchEvent(new Event("timeupdate"));
    }
    setIsVisible(true);
  };


  return (
    <>
      <Helmet>
            <script async type="text/javascript">
              {`  window.visiopt_code=window.visiopt_code||(function(){var visi_wid=1001,visi_pid=98,visi_flicker_time=4000,visi_flicker_element='html',c=false,d=document,visi_fn={begin:function(){var a=d.getElementById('visi_flicker');if(!a){var a=d.createElement('style'),b=visi_flicker_element?visi_flicker_element+'{opacity:0!important;background:none!important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','visi_flicker');a.setAttribute('type','text/css');if(a.styleSheet){a.styleSheet.cssText=b;}else{a.appendChild(d.createTextNode(b));}h.appendChild(a);}},complete:function(){c=true;var a=d.getElementById('visi_flicker');if(a){a.parentNode.removeChild(a);}},completed:function(){return c;},pack:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){visi_fn.complete();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){visi_fn.begin();setTimeout(function(){visi_fn.complete()},visi_flicker_time);this.pack('https://visiopt.com/client/js_test/test.'+visi_wid+'.'+visi_pid+'.js');return true;}};window.visiopt_code_status=visi_fn.init();return visi_fn;}());`}
            </script>
          </Helmet>
      {isVideoParamExists !== null && (
        <div className="w-full bg-white">
          {isVideoParamExists ? (
            <>
              <div
                className={
                  isVideoPlay === LOADER_STATUS.PLAY ? "hidden" : "w-full"
                }
              >
                <div className="bg-red-600 text-white font-medium p-3  text-center sm:text-xl text-lg  ">
                  <p>
                    Due to overwhelming interest, this free presentation is
                    available for a limited time!
                  </p>
                </div>
              </div>
              <div
                className={
                  isVideoPlay === LOADER_STATUS.PLAY
                    ? "w-full"
                    : "max-w-7xl mx-auto"
                }
              >
                <div
                  className={
                    isVideoPlay
                      ? "hidden"
                      : "p-3 pt-6 space-y-3 max-w-7xl text-center flex flex-col items-center justify-center"
                  }
                >
                  <h3 className="md:text-[28px] text-[23px] text-black font-bold ">
                    TOP US PULMONOLOGIST:{" "}
                  </h3>

                  <h3 className="lg:text-[40px] lg:leading-[48px] md:text-3xl text-[23px] leading-8  md:block hidden   text-[#dc252c] font-bold ">
                    “Do This Daily To Clear Stubborn Mucus <br /> & End
                    Breathlessness In 7 DAYS”
                  </h3>
                  <h3 className="lg:text-[40px] lg:leading-[48px] md:text-3xl text-[23px] leading-8 sm:px-5 px-0  md:hidden block   text-[#dc252c] font-bold ">
                    “Do This Daily To Clear Stubborn Mucus & End Breathlessness
                    In 7 DAYS”
                  </h3>
                </div>
                {/* //   Dynamically embed the player script */}
               <div className="w-full flex items-center justify-center">
                  <div
                    className={
                      isVideoPlay === LOADER_STATUS.PLAY
                        ? "w-full"
                        : "md:w-[70%] w-[90%]"
                    }
                    dangerouslySetInnerHTML={{
                      __html: `<script type="text/javascript" id="scr_6822683759717e1749dc7a51"></script>`,
                    }}
                  />

                  <Helmet>
                    <script type="text/javascript">
                      {` var s=document.createElement("script");
                     s.src="https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/6822683759717e1749dc7a51/player.js";
                      s.async=true;
                      document.head.appendChild(s);`}
                    </script>
                  </Helmet>
                </div>
                <div
                  id="smartplayer"
                  style={{
                    width: "100%",
                    position: "relative",
                    padding: "0",
                  }}
                ></div>

                <div className="flex items-center justify-center gap-2 my-7  max-w-7xl mx-auto text-center">
                  <img
                    src="https://cdn1.breatheagain.io/media/vsl/charm_sound.svg"
                    width="28"
                    height="28"
                    className="md:block hidden"
                  />
                  <p className="text-lg sm:text-xl font-semibold leading-6 text-black">
                    <span className="text-red-600 font-bold">IMPORTANT:</span>{" "}
                    Your video may take 10 seconds to load, Make sure your sound
                    is on.
                  </p>
                </div>
              </div>
              {isVisible && (
                <div
                  className="hide smartplayer-scroll-event"
                  id="hidden-section"
                >
                  <div className="md:block hidden ">
                    <div className="max-w-7xl mx-auto my-4 flex items-center justify-center ">
                      <img
                        src="https://cdn.blackincae.com/z8A-blue-arrow.png"
                        className="w-10 h-16"
                      />
                    </div>
                  </div>

                  <div ref={pricingRef}>
                    <PricingCards startTimer={startTimer} />
                  </div>
                  <WhyOrder />
                  <Gurantee />
                  <Bonuses />
                  <Contact />
                  <Testimonials />
                  <PricingCards startTimer={startTimer} />
                  <FAQ />
                  <NotificationRotator />
                </div>
              )}

              <TherapistInfo />
              {!isVisible && <CommentSection />}

              <ClinicalStudies onClickSkip={skipVideoAndShowCTA} />
            </>
          ) : (
            <>
              <div className="min-h-screen bg-navy-900">
                <Header />
                <Hero />
                <Features />
                <ScienceBack />
                <Pricing />
                <GuranteeLicence />
                <FAQs />
                <Pricing />
                {/* <ScientificReferences /> */}
                <Footer />
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default Fe;
